import { useEffect, useState, useCallback } from 'react';
import _ from 'lodash';
import { getUserDetails } from '../services/userprofileService';

const useUserDetails = (userId, forceRefresh = 0) => {
  const [userDetails, setUserDetails] = useState(null);

  const fetchDetails = useCallback(async () => {
    if (!userId) {
      setUserDetails(null);
      return;
    }

    try {
      const { errorCode, result } = await getUserDetails({ id: userId });

      if (errorCode === 0 && result) {
        setUserDetails(Array.isArray(result) ? result[0] : result);
      } else {
        setUserDetails(null);
      }
    } catch (err) {
      setUserDetails(null);
      console.log('Error', err);
    }
  }, [userId]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails, forceRefresh]);

  return userDetails;
};

export default useUserDetails;
